var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerHighlited(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 69,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#marker-highlited_svg__filter0_d_10445_61599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.602 28c0 8.011-5.938 14.728-13.931 16.527-1.375.31-2.81 5.473-4.287 5.473-1.477 0-2.912-5.164-4.287-5.473-7.993-1.8-13.931-8.516-13.931-16.527 0-9.389 8.157-17 18.218-17 10.062 0 18.218 7.611 18.218 17z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.602 28c0 7.489-5.559 13.843-13.151 15.551-.433.097-.766.357-1 .587-.243.24-.462.53-.655.82-.344.518-.687 1.156-1.003 1.746l-.108.202c-.364.676-.691 1.265-1.004 1.686a2.53 2.53 0 01-.297.343 2.53 2.53 0 01-.297-.343c-.313-.42-.64-1.01-1.004-1.686l-.108-.202c-.317-.59-.659-1.228-1.003-1.745a5.182 5.182 0 00-.655-.821c-.234-.23-.567-.49-1-.587C21.725 41.843 16.166 35.49 16.166 28c0-8.773 7.642-16 17.218-16 9.575 0 17.218 7.227 17.218 16zM33.276 49.02l.002-.002-.002.001zm.214-.002l.002.001-.002-.001z",
    stroke: "#DC4017",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "marker-highlited_svg__filter0_d_10445_61599",
    x: 0.166,
    y: 0,
    width: 66.436,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.768924 0 0 0 0 0.804634 0 0 0 0 0.895833 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10445_61599"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10445_61599",
    result: "shape"
  })))));
}
export default __webpack_public_path__ + "static/media/marker-highlited.d957208d.svg";
export { SvgMarkerHighlited as ReactComponent };